import { apiClient } from 'utils/ApiClient';
import { Logger } from 'utils/Logger';
import { CreateOnDemandPlaylistPayload, OnDemandPlaylist, OnDemandStatus } from './OnDemand.types';

const LOG_PREFIX = 'OnDemand.api';
const id = (value: string) => encodeURIComponent(value);

export const onDemandApi = {
    uploadFolderId: async (): Promise<string> => {
        const response = await apiClient.get<{ folderId: string }>('/bos/ods/upload-folder');
        const folderId = response.data?.folderId;
        if (!folderId) throw new Error('On Demand Upload folder was not returned');
        return folderId;
    },

    list: async (screenId: string, status: OnDemandStatus = 'queued'): Promise<OnDemandPlaylist[]> => {
        try {
            const response = await apiClient.get<{ playlists: OnDemandPlaylist[] }>(
                `/bos/ods/screens/${id(screenId)}/playlists?status=${encodeURIComponent(status)}`,
            );
            return response.data?.playlists ?? [];
        } catch (error) {
            Logger.error(LOG_PREFIX, `list(${screenId}) failed: ${error}`);
            throw error;
        }
    },

    create: async (screenId: string, payload: CreateOnDemandPlaylistPayload): Promise<OnDemandPlaylist> => {
        try {
            const response = await apiClient.post<OnDemandPlaylist>(`/bos/ods/screens/${id(screenId)}/playlists`, payload);
            if (!response.data) throw new Error('The playlist was not saved');
            return response.data;
        } catch (error) {
            Logger.error(LOG_PREFIX, `create(${screenId}) failed: ${error}`);
            throw error;
        }
    },
};
